import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {AddComparatorAdsError} from '../Errors/AddComparatorAdsError.js'
import {ComparatorAdAdsError} from '../Errors/ComparatorAdAdsError.js'
import {UpdateComparatorAdsService} from '../Services/UpdateComparatorAdsService.js'

const CUSTOM_ERRORS_BY_CODE = {
  [ComparatorAdAdsError.INVALID_AD_ERROR_CODE]: AddComparatorAdsError.createInvalidAdError
}

class AddComparatorAdsUseCase extends UseCase {
  #service

  #handleError(error) {
    if (AddComparatorAdsError.isAddComparatorAdsError({error})) return Promise.reject(error)
    if (CUSTOM_ERRORS_BY_CODE[error.code]) return Promise.reject(CUSTOM_ERRORS_BY_CODE[error.code]({cause: error}))
    return Promise.reject(AddComparatorAdsError.createGenericError({cause: error}))
  }

  constructor({service}) {
    super()
    this.#service = service
  }

  static create() {
    return new AddComparatorAdsUseCase({service: UpdateComparatorAdsService.create()})
  }

  @tracer({metric: 'AddComparatorAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({ad}) {
    try {
      const [error, response] = await this.#service.addAd({ad})
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = AddComparatorAdsUseCase.create
